export const ORG_HELP_ROUTE = '/org/help';
export const COMPANY_HELP_ROUTE = '/pages/help';

export interface HelpRouteState {
    /** Admin web oturumu (yalnız rol menüleri görünür; yardım yok). */
    readonly admin: boolean;
    readonly ent: boolean;
    readonly organization: boolean;
    readonly hasAccessToken: boolean;
}

/**
 * Üst çubuktaki Yardım'ın hedefi; AppMenu'nun yüzey seçimiyle aynı mantık. Organizasyon yüzeyinde (QR ile ent, ya da Keycloak'sız org
 * oturumu) Organizasyon yardımı, öteki girişlerde Şirket yardımı açılır. Eski Keycloak Organizasyon oturumunda /org rotaları açılmadığı
 * ve Şirket yardımı o menüyü anlatmadığı için bağlantı gösterilmez.
 */
export function helpRouteFor(s: HelpRouteState): string | null {
    if (s.admin) return null;
    if (!s.organization) return COMPANY_HELP_ROUTE;
    return s.ent || !s.hasAccessToken ? ORG_HELP_ROUTE : null;
}
